import React from "react";
import "./ChartEmptyState.css";

const ChartEmptyState = ({ graphHeight, variant }) => (
  <div
    className={`no-chart-data-img chart-empty-state chart-empty-state--${variant}`}
    style={graphHeight ? { height: graphHeight } : undefined}
    role="status"
  >
    <div className="chart-empty-state__content">
      <div className="chart-empty-state__icon" aria-hidden="true">
        <svg className="chart-empty-state__illustration" width="32" height="32" viewBox="0 0 32 32" fill="none">
          {variant === "pie" ? (
            <>
              <path d="M14 5a11 11 0 1 0 13 13H14V5Z" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
              <path d="M18 3v11h11A11 11 0 0 0 18 3Z" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
            </>
          ) : (
            <>
              <path d="M5 5v22h23" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
              <rect x="10" y="16" width="4" height="7" rx="1" fill="currentColor" opacity="0.45" />
              <rect x="17" y="10" width="4" height="13" rx="1" fill="currentColor" opacity="0.65" />
              <rect x="24" y="6" width="4" height="17" rx="1" fill="currentColor" />
            </>
          )}
        </svg>
      </div>
      <h5 className="chart-empty-state__title">No Data Found!</h5>
      <p className="chart-empty-state__description">There is no data to show you right now</p>
    </div>
  </div>
);

export default ChartEmptyState;
